import apiNotification from "../api";
const state = {
  countUnreadItems: 0,
  categoriesNotificationEmail: [],
  summaryNotificationList: [],
  eventsSummaryNotification: [],
  companiesSummaryNotification: [],
  listNotificationAll: [],
  countPageNotification: 0
};

const actions = {
  async getCategoriesNotificationEmail({ commit, state }) {
    const result = await apiNotification.getCategories();
    state.categoriesNotificationEmail = result.data;
  },

  async getSummaryNotification({ commit, state }) {
    const result = await apiNotification.all();
    state.summaryNotificationList = result.data;
    state.countUnreadItems = result.data.filter(
      item => item.read_at === null
    ).length;
  },

  async readAll({ dispatch, commit, state }, params) {
    await apiNotification.readAll();
    await dispatch("getFullListNotification", params);
  },

  async getFullListNotification(
    { commit, state },
    {
      perPage,
      page,
      notificationType = null,
      companyId = null,
      exhibitionId = null
    }
  ) {
    const result = await apiNotification.all(
      perPage,
      page,
      notificationType,
      companyId,
      exhibitionId
    );
    state.listNotificationAll = result.data;
    state.countUnreadItems = result.data.filter(
      item => item.read_at === null
    ).length;
    state.countPageNotification = result.meta?.last_page || 1;
  },

  async getExhibitions({ commit, state }) {
    const result = await apiNotification.getExhibitions();
    state.eventsSummaryNotification = result.data;
  },

  async getCompanies({ commit, state }) {
    const result = await apiNotification.getCompanies();
    state.companiesSummaryNotification = result.data;
  },

  async addPageListNotification(
    { commit, state },
    {
      perPage,
      page,
      notificationType = null,
      companyId = null,
      exhibitionId = null
    }
  ) {
    const result = await apiNotification.all(
      perPage,
      page,
      notificationType,
      companyId,
      exhibitionId
    );
    if (state.listNotificationAll.length) {
      state.listNotificationAll = [
        ...state.listNotificationAll,
        ...result.data
      ];
    } else {
      state.listNotificationAll = result.data;
    }
  },

  addNewNotification({ commit }, notification) {
    state.summaryNotificationList.unshift(notification);
    state.countUnreadItems++;
  }
};

export const notification = {
  namespaced: true,
  state,
  actions
};
